<div class="d-flex mb-3 h3 red">
    <ng-content></ng-content>
</div>